import * as React from 'react';
import { AnnotatorContext } from './types';

export default React.createContext({} as AnnotatorContext);
